import { render, staticRenderFns } from "./ClickAndBuyCompanyForm.vue?vue&type=template&id=3ab26fb8&scoped=true"
import script from "./ClickAndBuyCompanyForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab26fb8",
  null
  
)

export default component.exports